export interface SimpleActivityInterface {
  /**
   * 活动 id
   */
  activityId: number
  /**
   * 活动名
   */
  activity: string
  /**
   * 活动参与时间
   */
  createdAt: string
}

export class SimpleActivity implements SimpleActivityInterface {
  /**
   * 活动 id
   */
  activityId: number
  /**
   * 活动名
   */
  activity: string
  /**
   * 活动参与时间
   */
  createdAt: string

  constructor(props: SimpleActivityInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      activityId: _activityId,
      activity: _activity,
      createdAt: _createdAt,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.activityId = _activityId
    this.activity = _activity
    this.createdAt = _createdAt
  }
}
